module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-03.da4349fb.svg";